
export class RadWorkFinancialInfo {
    
    bsum: string;
    takhsum: string;
    psum: string;
    takhfif: string;
    jam_maliyat: string;
    jam_avarez: string;
    fsharh: string;
    hsharh: string;
    tarikhaction: string;
    hazine: string;
    mozo: string;
    code: string;

    constructor(
    bsum: string,
    takhsum: string,
    psum: string,
    takhfif: string,
    jam_maliyat: string,
    jam_avarez: string,
    fsharh: string,
    hsharh: string,
    tarikhaction: string,
    hazine: string,
    mozo: string,
    code: string
    ) {
        this.bsum = bsum;
        this.takhsum = takhsum;
        this.psum = psum;
        this.takhfif = takhfif;
        this.jam_maliyat = jam_maliyat;
        this.jam_avarez = jam_avarez;
        this.fsharh = fsharh;
        this.hsharh = hsharh;
        this.tarikhaction = tarikhaction;
        this.hazine = hazine;
        this.mozo = mozo;
        this.code = code;
    }

    public static fromJson(json: any): RadWorkFinancialInfo {
        return new RadWorkFinancialInfo(
            json["bsum"],
            json["takhsum"],
            json["psum"],
            json["takhfif"],
            json["jam_maliyat"],
            json["jam_avarez"],
            json["fsharh"],
            json["hsharh"],
            json["tarikhaction"],
            json["hazine"],
            json["mozo"],
            json["code"]
        );
    }
}